import dayjs from "dayjs";
import "dayjs/locale/en-gb";
import isoWeek from "dayjs/plugin/isoWeek";

dayjs.extend(isoWeek);

const WEEKDAY_LOCALE = "en-gb";

/**
 * Short weekday labels Mon–Sun aligned with ISO week (Jacques: derive from dayjs, not hardcoded English strings).
 */
export function getIsoWeekShortWeekdayLabels(referenceDate = dayjs()) {
    const monday = dayjs(referenceDate).startOf("isoWeek").locale(WEEKDAY_LOCALE);
    const labels = [];
    for (let i = 0; i < 7; i += 1) {
        labels.push(monday.add(i, "day").format("ddd"));
    }
    return labels;
}
